























import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation} from 'vuex-class'
import SurveyList from '@/components/survey/SurveyList.vue'
import SurveyNoDateList from '@/components/survey/SurveyNoDateList.vue'
import SurveyTimer from '@/components/survey/SurveyTimer.vue'
import SurveyCompleted from '@/components/survey/SurveyCompleted.vue'
import SurveyCanceled from '@/components/survey/SurveyCanceled.vue'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import {Task} from '@/store/types'

@Component({
  components: {
    SurveyList,
    SurveyNoDateList,
    SurveyTimer,
    SurveyCompleted,
    SurveyCanceled,
    AppHeader,
    AppFooter,
  },
})
export default class Surveys extends Vue {
  @Getter('taskCompleted') public taskCompleted!: Task
  @Getter('taskCanceled') public taskCanceled!: Task

  public doneTasks() {
    this.$router.push('/done')
  }

  public reload() {
    window.location.reload()
  }

}
